module.exports = "<section class=\"container tags-container pull-right\">\n    <h3>Active Flags / Tags</h3>\n\n    <tag-create ng-show=\"tagView.showCreate\"></tag-create>\n    \n    <tag-list ng-show=\"!tagView.showCreate\"></tag-list>\n</section>"


//////////////////
// WEBPACK FOOTER
// ./Client/app/tasks/tags/tag-container.html
// module id = 619
// module chunks = 0